<template>
    <section class="home-container">
        <MasterPage title="营养标准模板">
            <div slot="title-icon">
                <Icon type="md-analytics" />
            </div>
            <!--<div slot="searchContent" class="search-content-slot">-->
                <!--<Form :label-width="100">-->
                    <!--<Row>-->
                        <!--<Col span="12">-->
                        <!--<FormItem label="年龄：">-->
                            <!--<Input v-model="select.age" placeholder="请输入" />-->
                        <!--</FormItem>-->
                        <!--</Col>-->
                        <!--<Col span="12">-->
                        <!--<FormItem label="性别：">-->
                            <!--<Select v-model="select.sex" clearable @on-change="pageNum = 1" placeholder="请选择">-->
                                <!--<Option value="m" >男</Option>-->
                                <!--<Option value="f">女</Option>-->
                            <!--</Select>-->
                        <!--</FormItem>-->
                        <!--</Col>-->
                    <!--</Row>-->
                <!--</Form>-->
            <!--</div>-->
            <!--<div slot="search">-->
                <!--<Button type="primary" icon="md-add" @click="addItem_modal">添加</Button>-->
            <!--</div>-->
            <!--<div slot="btns">-->
                <!--<Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>-->
            <!--</div>-->
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <!--<div slot="pager">-->
                <!--<Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>-->
            <!--</div>-->
        </MasterPage>
        <Modal v-model="infoModel" v-if="infoItem" title="营养标准详情" width="70%">
            <Table stripe :columns="columnsInfo" :data="infoItem.infoList"></Table>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '年龄',
                        ellipsis: true,
                        tooltip: true,
                        align: 'center',
                        render: (h, params) => {
                            if (params.index === this.dataList.length -1) {
                                return h('span', this.dataList[params.index].age + ' 岁以上')
                            } else {
                                return h('span', this.dataList[params.index].age + ' - ' + this.dataList[params.index + 1].age + ' 岁')
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        render: (h, params) => {
                            let Buttons = [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.infoItem_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '详情')
                            ]
                            return h("div",Buttons)
                        }
                    }
                ],
                dataList: [],
                tableLoading:false,
                infoModel: false,
                select:{
                    age:null,
                    sex:null,
                },
                columnsInfo:[
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '营养物质',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h,params) => {
                            return h("span", params.row.nutritionType.name)
                        },
                    },
                    {
                        title: '目标',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h,params) => {
                            if (params.row.value !== null) {
                                return h("span", params.row.value + " " + params.row.nutritionType.unit)
                            }
                            return h("span", "-")
                        },
                    },
                    {
                        title: '适用人群',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h,params) => {
                            switch (params.row.sex) {
                                case 'f':
                                    return h("span", '女')
                                case 'm':
                                    return h("span", '男')
                                case 'mf':
                                    return h("span", '通用')
                            }
                        },
                    },
                ],
                infoItem: null,
                pageNum:1,
                pageSize:20,
                pageTotal:0,
            }
        },
        created(){
            this.pageFindItem()
        },
        methods:{
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            pageFindItem(){
                // if (this.select.age != null && /^[0-9]*$/.test(this.select.age) && parseInt(this.select.age) < 0) {
                //     this.$Notice.warning({title:'年龄输入有误'});
                // }
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('nutritionalGoal/listRequirement',{
                    age:this.select.age,
                    sex:this.select.sex,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data
                    }else {
                        this.$Notice.error({title:'营养标准模板列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            infoItem_modal(item){
                this.infoItem = item
                this.infoModel = true
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
</style>


